import { createContext } from 'react';

const AccommodationContext = createContext({});

export default AccommodationContext;
